var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderLetterPetroprix({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B363B",
    d: "M24.32 11.43a11.23 11.23 0 0 1-11.44 11.2h-4.9v10.28A7.46 7.46 0 0 1 .5 25.44V.22h12.34a11.23 11.23 0 0 1 11.47 11.21Zm-7.47 0a3.99 3.99 0 0 0-3.97-4.2h-4.9v8.4h4.9a4 4 0 0 0 3.97-4.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderLetterPetroprix);
export default __webpack_public_path__ + "static/media/loader-letter-petroprix.1d4f203a80a87b3220575138efa01157.svg";
export { ForwardRef as ReactComponent };